import React from 'react';
import { WalmartConnectTemplate } from 'themes/modules/channel/pages';
import { setCurrentView } from 'core/utils';
import { WalmartConnectViewStore } from 'modules/channel/stores';

@setCurrentView(rootStore => new WalmartConnectViewStore(rootStore), 'walmartConnectViewStore')
class WalmartConnect extends React.Component {
	render() {
		return <WalmartConnectTemplate {...this.props} viewStore={this.props.walmartConnectViewStore} />;
	}
}

export default WalmartConnect;
